import React from "react";
import { bool } from "prop-types";
import { connect, useDispatch } from "react-redux";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import Container from "pages/_components/Container";
import { ResponsiveHeader } from "pages/_components/header";

import * as i18nUtils from "util/i18n";
import { goBack } from "connected-react-router";
import { selectors as onboardingSelectors } from "reducers/onboarding";
import { selectors as enrollmentSelectors } from "reducers/enrollment";
import { selectors as modalselectors } from "reducers/modal";
import { selectors as alertselectors } from "reducers/alert";
import CustomText from "pages/_components/CustomText/CustomText";
import UserForm from "../LoginUser/_components/UserForm";
import Stepper from "../_components/Stepper";

const PAGE_ID = "StepVerifyUsername";

const StepVerifyUsername = ({ isDesktop, isMobile, onboardingWithEnrolledUser }) => {
    const dispatch = useDispatch();

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    return (
        <>
            <Notification scopeToShow="login" />
            {isMobile && (
                <ResponsiveHeader
                    ticket
                    id={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                    onClickBack={isMobile && onHeaderBack}
                />
            )}
            <MainContainer>
                {!isMobile && (
                    <Head
                        title={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                        onBack={isMobile && onHeaderBack}
                    />
                )}
                <Notification scopeToShow="login" />
                <Stepper isMobile={isMobile} page={PAGE_ID} />
                <Container className="items-center container--layout">
                    <h1>
                        <CustomText
                            textType="TEXT"
                            keepSpaceIfNoText
                            text={i18nUtils.get("onboarding.enrolled.user.verifyUsername.1", "Validá tus credenciales")}
                        />
                    </h1>
                    <CustomText
                        text={i18nUtils.get(
                            "onboarding.enrolled.user.verifyUsername.2",
                            "Ingresá tu usuario para continuar con tus credenciales",
                        )}
                    />
                    <UserForm isDesktop={isDesktop} isVerifyUserCredentialsForm />
                </Container>
            </MainContainer>
        </>
    );
};

StepVerifyUsername.propTypes = {
    isDesktop: bool.isRequired,
    isMobile: bool.isRequired,
    onboardingWithEnrolledUser: bool.isRequired,
};

const mapStateToProps = (state) => ({
    displayModal: modalselectors.getDisplayModal(state),
    verifyCode: onboardingSelectors.getVerifyCode(state),
    displayAlert: alertselectors.getDisplayAlert(state),
    exchangeToken: enrollmentSelectors.getExchangeToken(state),
    business: onboardingSelectors.getBusiness(state),
    onboardingWithEnrolledUser: onboardingSelectors.getOnboardingWithEnrolledUser(state),
});

export default connect(mapStateToProps)(StepVerifyUsername);
